import { useState, useCallback } from 'react';
import { omit, omitBy, isNil } from 'lodash';
import { useGenerateAssets } from './useGenerateAssets';
import { buildImageField } from '../components/modal/LandingPageBuilderModal';
import {
  ILandingPageBuilderBulkEditFormData,
  ILandingPageBuilderBulkEditPayload,
} from './getInitialLandingPageValuesForBulkEdit';

export const usePrepareLandingPageBulkData = () => {
  const { generateAssets, isGeneratingAssets } = useGenerateAssets();
  const [isPreparingBulkData, setIsPreparingBulkData] = useState(false);

  const prepareBulkData = useCallback(
    async (values: ILandingPageBuilderBulkEditFormData) => {
      setIsPreparingBulkData(true);

      const { bodyBackgroundImage, headerLogo } = values;

      const { bodyImageUrl, headerLogoUrl } = await generateAssets({
        bodyBackgroundImage: bodyBackgroundImage ?? undefined,
        headerLogo: headerLogo ?? undefined,
      });

      const payload: Partial<ILandingPageBuilderBulkEditPayload> = {
        ...omit(values, [
          'access',
          'uiKits',
          'selectedResellerId',
          'title',
          'category',
        ]),
        bodyBackgroundImage: bodyBackgroundImage?.file
          ? buildImageField(bodyBackgroundImage.file, bodyImageUrl)?.url
          : undefined,
        headerLogo: headerLogo?.file
          ? buildImageField(headerLogo.file, headerLogoUrl)?.url
          : undefined,
      };

      setIsPreparingBulkData(false);

      // Remove null or undefined fields
      const data = omitBy(payload, isNil);
      return data;
    },
    []
  );

  return { prepareBulkData, isPreparingBulkData, isGeneratingAssets };
};
